import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

// Modal
import { httpStatusCode } from '../../models/interfaces/HttpStatusCode';
import { Observable } from 'rxjs';
import { IOperationResult } from '../../models/interfaces/IOperationResult';
import { NotifyService } from '../notify/notify.service';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { OperationResult } from '../../models/class/OperationResult';
import { AlertComponent } from '../../modules/general/dialogs/alert/alert.component';
import { LoaderService } from './loader.service';
import { CanActivateService } from './can.active.service';

@Injectable()
export class AdditionalbaseService {
  constructor(
    private dialog: MatDialog,
    private _notifyService: NotifyService,
    private router: Router,
    private _loaderService: LoaderService,
  ) { }

  // Modal - Alert - Se muestra informacion de error al ejecutar un request de forma exitosa pero con un estatus distino de OK
  wrapperObservable(operador: Observable<IOperationResult>): any {
    return operador.pipe(
      map(
        data => {
          return this.Validation(data);
        },
        (        err: string) => {
          this._notifyService.error(err);
        }
      ));

  }

  wrapperPromise(operador: Observable<IOperationResult>): any {
    return operador
      .toPromise()
      .then((data: any) => {
        return this.Validation(data);
      })
      .catch(err => {
        this._notifyService.error(err);
      });
  }



  Validation(response: OperationResult): any {
    let x;
    if (response.status) {
      x = response.status.toString();
    }
    if (response.status !== httpStatusCode.OK) {
      if (response.status === httpStatusCode.NotFound) {
        this.router.navigate(['/error404']);
        // window.location.reload()
      } else if (response.status === httpStatusCode.Unauthorized) {
        this.router.navigate(['/error401'], { state: { data: 'permisos' } });
      } else if (response.status === httpStatusCode.InvalidToken) {
        this.router.navigate(['/error401'], { state: { data: 'token' } });
      } else if (response.status === httpStatusCode.InternalServerError) {
        this._notifyService.error(response.error);
        console.error(response.error);
        this._loaderService.display(false);
        // this.router.navigate(['/error500']);
        // this._notifyService.error(response.error, x, 5000);
      } else if (response.status === httpStatusCode.NotAcceptable) {
        this._notifyService.warning(response.error, 'Error', 5000);
      } else if (response.status === httpStatusCode.NoContent) {
        if (response.error) {
          this._notifyService.warning(response.error, 'Información!', 5000);
        }
      } else if (response.status === httpStatusCode.Continue) {
        if (response.error) {
          this._notifyService.warning(response.error, '', 5000);
          return response;
        }
      } else {
        this._notifyService.warning(response.error, 'Información!', 5000);
      }
    } else {
      return response.result;
    }
  }

  OpenAlert(message: any): any {
    const dialogRef = this.dialog.open(AlertComponent, {
      width: '400px',
      height: '350px',
      disableClose: true,
      data: {
        status: 'Error estatus: ' + message.status,
        error: 'Error Descripción: ' + message.error
      }
    });

    return dialogRef.afterClosed().toPromise();
  }
}
